<template>
    <div class="navigation">
        <input type="checkbox" class="navigation__checkbox navigation__nlpcheckbox" id="nlp-navi-toggle">
        <label ref="navigation__nlpbutton" for="nlp-navi-toggle" class="navigation__button">
            <span class="navigation__icon">&nbsp;</span>
        </label>
        <div class="navigation__background">&nbsp;</div>
        <nav class="navigation__nav __nav-s">
            <section class="section-tours" id="section-tours">
                <div class="row myview">
                    <div class="">
                        <div class="card">
                            <div class="card__side card__side--front">
                                <div class="card__picture card__picture--2">&nbsp;
                                    <h4 class="card__heading card__summary">
                                    <span class="card__heading-span card__heading-span-1">
                                        Article Highlights
                                    </span><br>
                                        <span class="card__heading-span card__heading-span--2">
                                            (Extractive text summarization )
                                    </span>
                                    </h4>
                                </div>

                                <div id="cardDetails" class="card__details" style="overflow-y: auto;height: 50vh;padding-bottom: 20rem;">
                                    <div class="u-center-text u-margin-bottom-medium row myview sum-rec">
                                        <h2 class="heading-secondary" @click="navigateToURL(url)"  style="cursor: pointer;">
                                            {{title}}
                                        </h2>
                                    </div>
                                    <ul>
                                        <template v-for="(s,i) in nlp_summary">
                                            <li v-html="s" v-bind:key="i"></li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                            <!--<div class="card__side card__side&#45;&#45;back card__side&#45;&#45;back-2">-->
                            <!--<div class="card__cta">-->
                            <!--<div class="card__price-box">-->
                            <!--<p class="card__price-only">Only</p>-->
                            <!--<p class="card__price-value">$497</p>-->
                            <!--</div>-->
                            <!--<a href="#popup" class="btn btn&#45;&#45;white">Book now!</a>-->
                            <!--</div>-->
                            <!--</div>-->
                        </div>
                    </div>
                </div>
                <!--<div class="u-center-text u-margin-top-huge">-->
                <!--<a href="#" class="btn btn&#45;&#45;green">Discover all tours</a>-->
                <!--</div>-->
            </section>
        </nav>

    </div>

</template>

<script>
    import MyCard from '@/components/MyCard';
    import * as d3 from "d3";
    import cloud from "d3-cloud";

    export default {
        components: {
            MyCard
        },
        data() {
            return {
                nlp_summary: [],
                title: String,
                url: String
            }
        },
        props: {},
        mounted() {
        },
        created() {
            // this.$refs.my_body.style.overflow='hidden';
            // console.log(this.$refs.my_body )

            this.$eventHub.$on('nlp-summary', this.displaySummary);
        },
        beforeDestroy() {
           // document.getElementsByTagName("body").style.overflow = 'scroll';
            // this.$eventHub.$off('filter-data');

        },
        methods: {
            // displayData(){
            //     this.displaySummary();
            //     this.displayWordCloud();
            // },
            navigateToURL(url) {
                window.open(url, '_blank')
            },
            displaySummary(data) {
                // ":",
                // Blocked Unblock Follow Following
                // clap


                let words = ['{', "}", "?", "!", "|", "│", "<%", "…", "//", "#", "...", ".com", "className", "function",
                    "<div", "</div>", "@idiot", "=>", "]", "[", "$", '=', "<head>", "<shortdiv", "df", "()", "»", "import",
                    'await','Follow Following', 'async', "Islands", "claps", "u0e", "\n\n\n", "\n \n \n \n \n", "\r\n\t", "\n\t\t\t", "\r\n\r\n"];

                this.nlp_summary = [];
                this.title = '';
                let myData = [], test = [];
                if (data && data.summary && data.summary.length > 0) {
                    for (let d = 0; d < data.summary.length; d++) {
                        let isWord = false;
                        for (let w = 0; w < words.length; w++) {
                            if (data.summary[d].toLowerCase().indexOf(words[w].toLowerCase()) > -1 && !isWord) {
                                isWord = true;
                                break;
                            }
                        }
                        if (!isWord) {
                            let s_data = data.summary[d];
                            let my_test = s_data.replace(/^a-zA-Z/g, '');
                            let my_test_data = my_test.replace(/&nbsp;/g, '').replace(/ /g, '');
                            // console.log(my_test_data);
                            if (!test.includes(my_test_data)) {
                                myData.push(data.summary[d]);
                                // sentence+=' '+data.summary[d];
                                test.push(my_test_data);
                            }
                        }
                    }
                }

                // try {
                //     this.nlp_summary = JSON.parse(data.summary);
                //     this.title = data.title;
                // }catch(e){
                this.nlp_summary = myData;
                this.title = data.title;
                this.url = data.url;
                // }
                // this.displayWordCloud(sentence);
                document.getElementById('cardDetails').scrollTop = 0;
                // document.getElementsByTagName("body")[0].style.overflow = 'hidden';
            },
            displayWordCloud(sentence) {
                function getFrequency(sentence) {
                    let counts = {};
                    let words = sentence.replace(/[!\.,:;\?]/g, '').split(' ');
                    for (let i = 0; i < words.length; i++) {
                        if (counts.hasOwnProperty(words[i])) {
                            counts[words[i]] += 1;
                        } else {
                            counts[words[i]] = 1
                        }
                    }
                    return counts;
                }

                // let word_list = getFrequency(sentence);
                // let frequency_list =Object.keys(word_list).map(function(key, index) {
                //     return {text: key.toString(), size: word_list[key] *20};
                // });
                let fill = d3.scaleOrdinal(d3.schemeCategory10);
                let frequency_list = [
                    {"text": "NLP", "size": 50},
                    {"text": "Dataset", "size": 50},
                    {"text": "Entity", "size": 50},
                    {"text": "Corpus", "size": 50},
                    {"text": "Summarization", "size": 50},
                    {"text": "Analysis", "size": 50},
                    {"text": "Bag", "size": 50},
                    {"text": "Words", "size": 50},
                    {"text": "Corpora", "size": 50},
                    {"text": "document", "size": 50},
                    {"text": "machine", "size": 50},
                    {"text": "NLTK", "size": 50},
                    {"text": "data", "size": 50},
                    {"text": "Sentence", "size": 50},
                    {"text": "Tokenization", "size": 50},
                    {"text": "Text", "size": 50},
                    {"text": "Lemmatization", "size": 50},
                    {"text": "Stop-Words", "size": 50},
                    {"text": "Regex", "size": 50},
                    {"text": "TF-IDF", "size": 50},
                    // {"text":"Computer","size":10},
                    // {"text":"Vision","size":10},
                    // {"text":"Supervised","size":20},
                    // {"text":"relation","size":10},
                    // {"text":"Unsupervised","size":20},
                    // {"text":"Reinforcement","size":10},
                    // {"text":"Neural","size":20},
                    // {"text":"Overfitting","size":10},
                    // {"text":"living","size":10},
                    // {"text":"Learning","size":50},
                    // {"text":"Extraction","size":50},
                    // {"text":"Information","size":20},
                    // {"text":"velocity","size":10},
                    // {"text":"NER","size":50},
                    // {"text":"Sentiment","size":10},
                    // {"text":"Semantic","size":10},
                    // {"text":"Explicit","size":10},
                    // {"text":"Latent","size":10},
                    // {"text":"Dirichlet","size":10},
                    // {"text":"Allocation","size":10},
                    // {"text":"Disambiguation","size":10},
                    // {"text":"Recognition","size":10},
                    // {"text":"fitting","size":10},
                    // {"text":"translation","size":10},
                    // {"text":"spam","size":10},
                    // {"text":"detection","size":10},
                    // {"text":"question","size":10},
                    // {"text":"answering","size":10},
                    // {"text":"autocomplete","size":10},
                    // {"text":"predictive","size":10},
                    // {"text":"typing","size":10},
                    // {"text":"voice","size":10},
                    // {"text":"Natural","size":20},
                    // {"text":"Language","size":10},
                    // {"text":"resources","size":20},
                    // {"text":"string","size":20},
                    // {"text":"boundaries","size":10},
                    // {"text":"dividing","size":10},
                    // {"text":"nouns","size":10},
                    // {"text":"English","size":10},
                    // {"text":"variably","size":10}
                ];

                // let fill = d3.scaleLinear()
                //     .domain([0, 1, 2, 3, 4, 5, 6, 10, 15, 20, 100])
                //     .range(["#ddd", "#ccc", "#bbb", "#aaa", "#999", "#888", "#777", "#666", "#555", "#444", "#333", "#222"]);

                cloud().size([800, 300])
                    .words(frequency_list)
                    .rotate(0)
                    .fontSize(function (d) {
                        return d.size;
                    })
                    .on("end", draw)
                    .start();

                function draw(words) {
                    d3.select("svg").remove();
                    d3.select("#my-cloud").append("svg")
                    // .attr("width", 850)
                    // .attr("height", 350)
                        .attr("class", "wordcloud")
                        .append("g")
                        // without the transform, words words would get cutoff to the left and top, they would
                        // appear outside of the SVG area
                        // .attr("transform", "translate(320,200)")
                        .selectAll("text")
                        .data(words)
                        .enter().append("text")
                        .style("font-size", function (d) {
                            return d.size + "px";
                        })
                        .style("fill", function (d, i) {
                            return fill(i);
                        })
                        .attr("transform", function (d) {
                            return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
                        })
                        .text(function (d) {
                            return d.text;
                        });
                }
            }
            // displayWordCloud() {
            //     //Simple animated example of d3-cloud - https://github.com/jasondavies/d3-cloud
            //     //Based on https://github.com/jasondavies/d3-cloud/blob/master/examples/simple.html
            //
            //     // Encapsulate the word cloud functionality
            //     function wordCloud(selector) {
            //
            //         // var fill = d3.scale.category20();
            //         var fill = d3.scaleOrdinal(d3.schemeCategory10);
            //         //Construct the word cloud's SVG element
            //         var svg = d3.select(selector).append("svg")
            //             .attr("width", 500)
            //             .attr("height", 500)
            //             .append("g")
            //             .attr("transform", "translate(250,250)");
            //
            //
            //         //Draw the word cloud
            //         function draw(words) {
            //             let _cloud = svg.selectAll("g text")
            //                 .data(words, function (d) {
            //                     return d.text;
            //                 });
            //
            //             //Entering words
            //             _cloud.enter()
            //                 .append("text")
            //                 .style("font-family", "Impact")
            //                 .style("fill", function (d, i) {
            //                     return fill(i);
            //                 })
            //                 .attr("text-anchor", "middle")
            //                 .attr('font-size', 1)
            //                 .text(function (d) {
            //                     return d.text;
            //                 });
            //
            //             //Entering and existing words
            //             _cloud
            //                 .transition()
            //                 .duration(600)
            //                 .style("font-size", function (d) {
            //                     return d.size + "px";
            //                 })
            //                 .attr("transform", function (d) {
            //                     return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
            //                 })
            //                 .style("fill-opacity", 1);
            //
            //             //Exiting words
            //             _cloud.exit()
            //                 .transition()
            //                 .duration(200)
            //                 .style('fill-opacity', 1e-6)
            //                 .attr('font-size', 1)
            //                 .remove();
            //         }
            //
            //
            //         //Use the module pattern to encapsulate the visualisation code. We'll
            //         // expose only the parts that need to be public.
            //         return {
            //
            //             //Recompute the word cloud for a new set of words. This method will
            //             // asycnhronously call draw when the layout has been computed.
            //             //The outside world will need to call this function, so make it part
            //             // of the wordCloud return value.
            //             update: function (words) {
            //                 cloud().size([500, 500])
            //                     .words(words)
            //                     .padding(5)
            //                     .rotate(function () {
            //                         return ~~(Math.random() * 2) * 90;
            //                     })
            //                     .font("Impact")
            //                     .fontSize(function (d) {
            //                         return d.size;
            //                     })
            //                     .on("end", draw)
            //                     .start();
            //             }
            //         }
            //
            //     }
            //
            //     //Some sample data - http://en.wikiquote.org/wiki/Opening_lines
            //     let words = [
            //         "You don't know about me without you have read a book called The Adventures of Tom Sawyer but that ain't no matter.",
            //         "The boy with fair hair lowered himself down the last few feet of rock and began to pick his way toward the lagoon.",
            //         "When Mr. Bilbo Baggins of Bag End announced that he would shortly be celebrating his eleventy-first birthday with a party of special magnificence, there was much talk and excitement in Hobbiton.",
            //         "It was inevitable: the scent of bitter almonds always reminded him of the fate of unrequited love."
            //     ];
            //
            //     //Prepare one of the sample sentences by removing punctuation,
            //     // creating an array of words and computing a random size attribute.
            //     function getWords(i) {
            //         return words[i]
            //             .replace(/[!\.,:;\?]/g, '')
            //             .split(' ')
            //             .map(function (d) {
            //                 return {text: d, size: 10 + Math.random() * 60};
            //             })
            //     }
            //
            //     //This method tells the word cloud to redraw with a new set of words.
            //     //In reality the new words would probably come from a server request,
            //     // user input or some other source.
            //     function showNewWords(vis, i) {
            //         i = i || 0;
            //
            //         vis.update(getWords(i++ % words.length));
            //         // setTimeout(function () {
            //         //     showNewWords(vis, i + 1)
            //         // }, 2000)
            //     }
            //     //Create a new instance of the word cloud visualisation.
            //     var myWordCloud = wordCloud('#my-cloud');
            //
            //     //Start cycling through the demo data
            //     showNewWords(myWordCloud);
            // }
        }
    }
</script>

<style lang="scss">

    /*!* desert scheme ported from vim to google prettify *!*/
    /*pre.prettyprint { display: block; background-color: #333 }*/
    /*pre .nocode { background-color: none; color: #000 }*/
    /*pre .str { color: #ffa0a0 } !* string  - pink *!*/
    /*pre .kwd { color: #f0e68c; font-weight: bold }*/
    /*pre .com { color: #87ceeb } !* comment - skyblue *!*/
    /*pre .typ { color: #98fb98 } !* type    - lightgreen *!*/
    /*pre .lit { color: #cd5c5c } !* literal - darkred *!*/
    /*pre .pun { color: #fff }    !* punctuation *!*/
    /*pre .pln { color: #fff }    !* plaintext *!*/
    /*pre .tag { color: #f0e68c; font-weight: bold } !* html/xml tag    - lightyellow *!*/
    /*pre .atn { color: #bdb76b; font-weight: bold } !* attribute name  - khaki *!*/
    /*pre .atv { color: #ffa0a0 } !* attribute value - pink *!*/
    /*pre .dec { color: #98fb98 } !* decimal         - lightgreen *!*/

    /*!* Specify class=linenums on a pre to get line numbering *!*/
    /*ol.linenums { margin-top: 0; margin-bottom: 0; color: #AEAEAE } !* IE indents via margin-left *!*/
    /*li.L0,li.L1,li.L2,li.L3,li.L5,li.L6,li.L7,li.L8 { list-style-type: none }*/
    /*!* Alternate shading for lines *!*/
    /*li.L1,li.L3,li.L5,li.L7,li.L9 { }*/

    /*@media print {*/
    /*pre.prettyprint { background-color: none }*/
    /*pre .str, code .str { color: #060 }*/
    /*pre .kwd, code .kwd { color: #006; font-weight: bold }*/
    /*pre .com, code .com { color: #600; font-style: italic }*/
    /*pre .typ, code .typ { color: #404; font-weight: bold }*/
    /*pre .lit, code .lit { color: #044 }*/
    /*pre .pun, code .pun { color: #440 }*/
    /*pre .pln, code .pln { color: #000 }*/
    /*pre .tag, code .tag { color: #006; font-weight: bold }*/
    /*pre .atn, code .atn { color: #404 }*/
    /*pre .atv, code .atv { color: #060 }*/
    /*}*/
</style>
